// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.page-wrap[data-v-0393b99c] {\n  width: 1060px;\n  padding-top: 50px;\n  margin-left: auto;\n  margin-right: auto;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
